export const CONFIG = {
  BASE_URL_API: process.env.REACT_APP_API_ENDPOINT + "api/" || "",
  BASE_URL: process.env.REACT_APP_API_ENDPOINT || "",
};
